/** CHANGES: the patch notes, newest first - opened from the version number in the title screen's corner. */

import '../options.css';
import type { Ctx, Screen } from '../context';
import { box, button, el } from '../dom';
import { frame } from '../widgets/frame';
import { RELEASES } from './changelog';

export function changesScreen(ctx: Ctx): Screen {
  const f = frame('credits', 'CHANGES');
  const text = el('div', 'menu-credits menu-prose');
  for (const release of RELEASES) {
    text.append(el('div', 'menu-credits-head', `V${release.version} - ${release.date}`));
    for (const change of release.changes) text.append(el('div', '', `- ${change}`));
  }
  const back = button('BACK', () => ctx.nav.title());
  f.body.append(box('menu-col menu-grow menu-scroll', text), box('menu-col menu-options-side', back));
  return { el: f.el, back: () => ctx.nav.title(), initialFocus: () => back };
}
